import type { LineStyle } from '../measurements/measurement';

export interface GeoJsonLike {
  readonly type: string;
  readonly coordinates?: unknown;
  readonly geometry?: GeoJsonLike | null;
  readonly features?: readonly GeoJsonLike[];
}

export interface GeofencePolygonStyle {
  readonly color: string;
  readonly fillOpacity: number;
  readonly lineThickness: number;
  readonly lineStyle: LineStyle;
}

export interface GeofencePolygonInput {
  readonly id: string;
  readonly geometry: GeoJsonLike;
  readonly style?: Partial<GeofencePolygonStyle>;
  /**
   * Defaults to the provider's active coordinate space: `lonlat` for WGS84 imports,
   * or `scene` for project-grid coordinates on calibrated projects.
   */
  readonly coordinateSpace?: GeofenceCoordinateSpace;
}

export type GeofencePolygonSkipReason =
  | 'unsupported-geometry'
  | 'invalid-coordinates'
  | 'too-few-vertices'
  | 'self-intersecting'
  | 'render-failed';

export interface GeofencePolygonSkipped {
  readonly id: string;
  readonly reason: GeofencePolygonSkipReason;
}

export type GeofencePositionResolver = (
  lon: number,
  lat: number
) => { readonly x: number; readonly y: number };

export interface GeofencePolygonsOptions {
  readonly defaultStyle?: Partial<GeofencePolygonStyle>;
  readonly elevationOffset?: number;
}

export type GeofenceCoordinateSpace = 'lonlat' | 'scene';

export const GEOFENCE_POLYGON_ORIGIN = Symbol.for(
  'trimble.web3d-providers.geofence-polygons'
);

export type GeofencePolygonEmphasis = 'none' | 'highlighted' | 'selected';
